import React from "react";
import { LockOutlined } from "@mui/icons-material";
import { Alert, Box, Typography } from "@mui/material";
import WorkflowPifTextField from "./WorkflowPifTextField";
import { PifSectionProps, pifDetailsMode } from "./pifDetailsModel";
import { PIF_DETAILS_FIELDS } from "./pifWorkflowKeys";

const F = PIF_DETAILS_FIELDS;

/**
 * pif-3 Applicant: the name. An existing employee's comes from the employee record and a rehire's
 * is carried over, both locked; a new hire types it, and only a new hire is asked "Known as" and
 * "Suffix" (P6). The SSN is never shown or stored here.
 */
const WorkflowPifIdentitySection: React.FC<PifSectionProps> = ({ identity, values, errors, onChange }) => {
  const { identityLocked, asksKnownNameAndSuffix } = pifDetailsMode(identity.flow);
  const field = { values, errors, onChange };

  return (
    <>
      {identity.flow === "existing-active" && (
        <Alert severity="info" icon={<LockOutlined />} className="workflow-run__alert--flush">
          Existing active employee — personal fields are locked and the SSN remains masked. Choose a
          position switch or addition below.
        </Alert>
      )}
      {identity.flow === "rehire" && (
        <Alert severity="info" icon={<LockOutlined />} className="workflow-run__alert--flush">
          Rehire — identity carries over locked. Confirm the contact details below.
        </Alert>
      )}

      <Typography component="h3" className="workflow-run__section-title">
        Applicant
      </Typography>
      <Box className="workflow-run__grid">
        <WorkflowPifTextField {...field} fieldKey={F.firstName} label="First name" required locked={identityLocked} />
        <WorkflowPifTextField {...field} fieldKey={F.middleName} label="Middle name" locked={identityLocked} />
        <WorkflowPifTextField {...field} fieldKey={F.lastName} label="Last name" required locked={identityLocked} />
        {asksKnownNameAndSuffix && (
          <>
            <WorkflowPifTextField {...field} fieldKey={F.knownName} label="Known as" />
            <WorkflowPifTextField {...field} fieldKey={F.suffix} label="Suffix" maxLength={20} />
          </>
        )}
      </Box>
    </>
  );
};

export default WorkflowPifIdentitySection;
